export const baseUrl = 'denticare';

export const ApiMedicalHistory = {
  MHQEndpoint: `${baseUrl}/client/mhq`
};
